/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  InCreateMerchantDTO,
  InDetailedMerchantDTO,
  MerchantListResponseDTO,
  OutDetailedMerchantDTO
} from "../models";
import {
  InCreateMerchantDTOFromJSON,
  InCreateMerchantDTOToJSON,
  InDetailedMerchantDTOFromJSON,
  InDetailedMerchantDTOToJSON,
  MerchantListResponseDTOFromJSON,
  MerchantListResponseDTOToJSON,
  OutDetailedMerchantDTOFromJSON,
  OutDetailedMerchantDTOToJSON
} from "../models";

export interface DeleteByMerchantIdRequest {
  merchantId: number;
}

export interface FindAllMerchantsByFiltersRequest {
  platformId: number;
  skip: number;
  take: number;
  filters?: string;
  status?: FindAllMerchantsByFiltersStatusEnum;
}

export interface GetEditMerchantByIdRequest {
  merchantId: number;
}

export interface GetMerchantBySlugRequest {
  merchantSlug: string;
  platformId: number;
}

export interface GetMerchantCountRequest {
  platformId: number;
  filters?: string;
  status?: GetMerchantCountStatusEnum;
}

export interface GetMerchantsByIdsRequest {
  platformId: number;
  ids?: string;
  labelFilter?: string;
}

export interface GetMerchantsExtendedRequest {
  skip: number;
  take: number;
  platformId?: number;
  live?: string;
  approved?: string;
  editFilter?: GetMerchantsExtendedEditFilterEnum;
  searchQuery?: string;
}

export interface PostMerchantRequest {
  inCreateMerchantDTO: InCreateMerchantDTO;
}

export interface PutMerchantRequest {
  merchantId: number;
  inDetailedMerchantDTO: InDetailedMerchantDTO;
}

/**
 *
 */
export class MerchantsApi extends runtime.BaseAPI {
  /**
   */
  async deleteByMerchantIdRaw(
    requestParameters: DeleteByMerchantIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.merchantId === null || requestParameters.merchantId === undefined) {
      throw new runtime.RequiredError(
        "merchantId",
        "Required parameter requestParameters.merchantId was null or undefined when calling deleteByMerchantId."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/merchants/{merchantId}`.replace(
          `{${"merchantId"}}`,
          encodeURIComponent(String(requestParameters.merchantId))
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteByMerchantId(
    requestParameters: DeleteByMerchantIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.deleteByMerchantIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async findAllMerchantsByFiltersRaw(
    requestParameters: FindAllMerchantsByFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MerchantListResponseDTO>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling findAllMerchantsByFilters."
      );
    }

    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling findAllMerchantsByFilters."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling findAllMerchantsByFilters."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/merchants`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => MerchantListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async findAllMerchantsByFilters(
    requestParameters: FindAllMerchantsByFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MerchantListResponseDTO> {
    const response = await this.findAllMerchantsByFiltersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getEditMerchantByIdRaw(
    requestParameters: GetEditMerchantByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDetailedMerchantDTO>> {
    if (requestParameters.merchantId === null || requestParameters.merchantId === undefined) {
      throw new runtime.RequiredError(
        "merchantId",
        "Required parameter requestParameters.merchantId was null or undefined when calling getEditMerchantById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/merchants/{merchantId}`.replace(
          `{${"merchantId"}}`,
          encodeURIComponent(String(requestParameters.merchantId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDetailedMerchantDTOFromJSON(jsonValue));
  }

  /**
   */
  async getEditMerchantById(
    requestParameters: GetEditMerchantByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDetailedMerchantDTO> {
    const response = await this.getEditMerchantByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getMerchantBySlugRaw(
    requestParameters: GetMerchantBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDetailedMerchantDTO>> {
    if (requestParameters.merchantSlug === null || requestParameters.merchantSlug === undefined) {
      throw new runtime.RequiredError(
        "merchantSlug",
        "Required parameter requestParameters.merchantSlug was null or undefined when calling getMerchantBySlug."
      );
    }

    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getMerchantBySlug."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/merchants/slug/{merchantSlug}`.replace(
          `{${"merchantSlug"}}`,
          encodeURIComponent(String(requestParameters.merchantSlug))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDetailedMerchantDTOFromJSON(jsonValue));
  }

  /**
   */
  async getMerchantBySlug(
    requestParameters: GetMerchantBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDetailedMerchantDTO> {
    const response = await this.getMerchantBySlugRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getMerchantCountRaw(
    requestParameters: GetMerchantCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<number>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getMerchantCount."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/merchants/count`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<number>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async getMerchantCount(
    requestParameters: GetMerchantCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<number> {
    const response = await this.getMerchantCountRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getMerchantsByIdsRaw(
    requestParameters: GetMerchantsByIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MerchantListResponseDTO>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getMerchantsByIds."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.ids !== undefined) {
      queryParameters["ids"] = requestParameters.ids;
    }

    if (requestParameters.labelFilter !== undefined) {
      queryParameters["labelFilter"] = requestParameters.labelFilter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/merchants/bulk`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => MerchantListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getMerchantsByIds(
    requestParameters: GetMerchantsByIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MerchantListResponseDTO> {
    const response = await this.getMerchantsByIdsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getMerchantsExtendedRaw(
    requestParameters: GetMerchantsExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MerchantListResponseDTO>> {
    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling getMerchantsExtended."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling getMerchantsExtended."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.live !== undefined) {
      queryParameters["live"] = requestParameters.live;
    }

    if (requestParameters.approved !== undefined) {
      queryParameters["approved"] = requestParameters.approved;
    }

    if (requestParameters.editFilter !== undefined) {
      queryParameters["editFilter"] = requestParameters.editFilter;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/merchants/extended`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => MerchantListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getMerchantsExtended(
    requestParameters: GetMerchantsExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MerchantListResponseDTO> {
    const response = await this.getMerchantsExtendedRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async postMerchantRaw(
    requestParameters: PostMerchantRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDetailedMerchantDTO>> {
    if (requestParameters.inCreateMerchantDTO === null || requestParameters.inCreateMerchantDTO === undefined) {
      throw new runtime.RequiredError(
        "inCreateMerchantDTO",
        "Required parameter requestParameters.inCreateMerchantDTO was null or undefined when calling postMerchant."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/merchants`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: InCreateMerchantDTOToJSON(requestParameters.inCreateMerchantDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDetailedMerchantDTOFromJSON(jsonValue));
  }

  /**
   */
  async postMerchant(
    requestParameters: PostMerchantRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDetailedMerchantDTO> {
    const response = await this.postMerchantRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async putMerchantRaw(
    requestParameters: PutMerchantRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDetailedMerchantDTO>> {
    if (requestParameters.merchantId === null || requestParameters.merchantId === undefined) {
      throw new runtime.RequiredError(
        "merchantId",
        "Required parameter requestParameters.merchantId was null or undefined when calling putMerchant."
      );
    }

    if (requestParameters.inDetailedMerchantDTO === null || requestParameters.inDetailedMerchantDTO === undefined) {
      throw new runtime.RequiredError(
        "inDetailedMerchantDTO",
        "Required parameter requestParameters.inDetailedMerchantDTO was null or undefined when calling putMerchant."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/merchants/{merchantId}`.replace(
          `{${"merchantId"}}`,
          encodeURIComponent(String(requestParameters.merchantId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: InDetailedMerchantDTOToJSON(requestParameters.inDetailedMerchantDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDetailedMerchantDTOFromJSON(jsonValue));
  }

  /**
   */
  async putMerchant(
    requestParameters: PutMerchantRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDetailedMerchantDTO> {
    const response = await this.putMerchantRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const FindAllMerchantsByFiltersStatusEnum = {
  ABOUT_TO_START: "ABOUT_TO_START",
  ONGOING: "ONGOING",
  ABOUT_TO_EXPIRE: "ABOUT_TO_EXPIRE",
  EXPIRED: "EXPIRED"
} as const;
export type FindAllMerchantsByFiltersStatusEnum =
  typeof FindAllMerchantsByFiltersStatusEnum[keyof typeof FindAllMerchantsByFiltersStatusEnum];
/**
 * @export
 */
export const GetMerchantCountStatusEnum = {
  ABOUT_TO_START: "ABOUT_TO_START",
  ONGOING: "ONGOING",
  ABOUT_TO_EXPIRE: "ABOUT_TO_EXPIRE",
  EXPIRED: "EXPIRED"
} as const;
export type GetMerchantCountStatusEnum = typeof GetMerchantCountStatusEnum[keyof typeof GetMerchantCountStatusEnum];
/**
 * @export
 */
export const GetMerchantsExtendedEditFilterEnum = {
  approved: "approved",
  merchant: "merchant"
} as const;
export type GetMerchantsExtendedEditFilterEnum =
  typeof GetMerchantsExtendedEditFilterEnum[keyof typeof GetMerchantsExtendedEditFilterEnum];
